// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer } from "@rails/actioncable";
import { getAccessToken } from "modules/auth/token";

// Recreate when token changes so cable gets ?token=
let consumer = null;
let lastToken = null;

export default function getCableConsumer() {
  const token = getAccessToken();
  if (!consumer || token !== lastToken) {
    if (consumer) {
      consumer.disconnect();
    }
    const url = token ? `/cable?token=${encodeURIComponent(token)}` : "/cable";
    consumer = createConsumer(url);
    lastToken = token;
  }
  return consumer;
}
